import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface PinnedAppsStore {
  pinned: string[];
  isPinned: (appId: string) => boolean;
  pin: (appId: string) => void;
  unpin: (appId: string) => void;
  toggle: (appId: string) => void;
}

export const usePinnedAppsStore = create<PinnedAppsStore>()(
  persist(
    (set, get) => ({
      pinned: ["messenger"],
      isPinned: (appId) => get().pinned.includes(appId),
      pin: (appId) =>
        set((state) =>
          state.pinned.includes(appId) ? state : { pinned: [...state.pinned, appId] }
        ),
      unpin: (appId) =>
        set((state) => ({ pinned: state.pinned.filter((id) => id !== appId) })),
      toggle: (appId) =>
        set((state) =>
          state.pinned.includes(appId)
            ? { pinned: state.pinned.filter((id) => id !== appId) }
            : { pinned: [...state.pinned, appId] }
        ),
    }),
    {
      name: "slumbr-pinned-apps",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
